module.exports = __webpack_public_path__ + "img/service-fenan4.89c2c15d.svg";